import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import Button from '@dbk/ui-buttons';
import { Radio,  TextInput } from '@dbk/ui-forms';
import { PALETTE } from '../../../constants';

/* WMCE-2889, 2891 search functionality header implemented for RM-Access */
class SearchViewHeader extends PureComponent {
    constructor(props){
        super(props);
    
        this.state = {
            textValue: null,
            openErrorToast: false,
            radioOptions: [
                {
                    value: 'Contract Number',
                    isChecked: false,
                    title: 'app.rmAccess.searchBy.CN'
                },
                {
                    value: 'Business Partner',
                    isChecked: true,
                    title:'app.rmAccess.searchBy.BP'
                },
            ],
            selectedRadio: this.props.i18n.messages['app.rmAccess.searchBy.BP'],
            BPCNvalue: undefined,
            searchActive: false
        }
        this.renderRadioView = this.renderRadioView.bind(this);
        this.handleRadioChange = this.handleRadioChange.bind(this);
        this.deselectAll = this.deselectAll.bind(this);
    }
    
    handleTextChange = (ev) => {
        const BPCNValue = document.getElementById("BPCNvalueSelection").value;
        this.setState({
            BPCNvalue: BPCNValue,
        });
        if(!BPCNValue){
            this.props.rmAccess.resetSearchVariables();
        }
    }

    /* Handler to implement /getcontracts API on Search Button Click */
    handleSearchClick = async () => {
        const {
            i18n : {messages},
            rmAccess: {getContractsList}
        } = this.props;
        const BPCNValue = document.getElementById("BPCNvalueSelection").value;
        if(this.state.selectedRadio === messages['app.rmAccess.searchBy.BP']){
        await getContractsList(BPCNValue, "");
        }
        else
        await getContractsList("", BPCNValue);
    }

    /* Handler to reset all variables on Reset Button */
    handleResetClick = () => {
        this.setState({
            selectedRadio: this.props.i18n.messages['app.rmAccess.searchBy.BP'],
            BPCNvalue: undefined,
        })
        this.deselectAll();
        document.getElementById("BPCNvalueSelection").value = null;
        this.props.rmAccess.resetSearchVariables();
    }

    deselectAll() {
        const getList = this.state.radioOptions;
        const selectedOptions = [];
        getList.forEach((item) => {
            item.isChecked = false;
            selectedOptions.push(item);
        }); 
        this.setState({
            radioOptions: selectedOptions
        });
      }
    
    /* Handler to help toggle between the radio buttons */
    async handleRadioChange(e, item) {
        this.deselectAll();
        const arrayList = this.state.radioOptions;
        const selectedOptions = [];
        arrayList.forEach((dataRow) => {
          if (dataRow.value === item.value) {
            dataRow.isChecked = true;
            selectedOptions.push(dataRow);
            
          }
        });
        document.getElementById("BPCNvalueSelection").value = null;
        this.setState({
            selectedStates: selectedOptions,
            selectedRadio: item.value,
            BPCNvalue: undefined,
        });
        await this.props.rmAccess.resetSearchVariables();
      }
    
    /* Function to render the radio buttons in Search View */
    renderRadioView(){
        const options = this.state.radioOptions;
        return (
                options.map((item) => {
                    const { title} = item;
                    return (
                    <span className="margin-left-15">
                    <Radio value="value"
                    checked={this.state.selectedRadio === item.value}
                    onChange={(e) => this.handleRadioChange(e, item)}/>
                    <span className="rm-general-font margin-left-5">{this.props.i18n.messages[title]}</span>
                    </span>
                    );
                })
                
          );
    }

    onRMLogout = () => {
        //  Here we call the RM logout and not DWO logout 
        this.props.rmLogout();
      }
    
    render(){
        const { i18n: { messages } } = this.props;

        return (
            <div >
                <div className="rm-columns">
                    <span className="rm-title">{messages['app.rmAccess.search.title']}</span>
                    <span className="rm-general-font rm-subtitle"
                    style={{ color: PALETTE.primaryActive }}>{messages['app.rmAccess.search.subtitle']}</span>
                    <Button className="button-height rm-logout"
                            fullWidth
                            loading = {this.props.rmAccess.showLogoutSpinner}
                            tertiary
                            size='large'
                            onPress={this.onRMLogout}
                        >{messages['app.auth.logoutConfirm.title']}</Button>
                </div>
                <div className = "line-block"/>
                <div className="rm-columns" >
                    <span className="rm-search-text primary">{messages['app.rmAccess.searchBy.title']}</span>
                    {this.renderRadioView()}
                </div>
                <div className="rm-textButton-container row">
                    <div className="column rm-textInput-style">
                    <TextInput
                        id="BPCNvalueSelection"
                        size="large"
                        value={this.state.BPCNvalue}
                        placeholder={this.state.selectedRadio === 'Contract Number'? messages['app.rmAccess.placeholder.title.CN']:messages['app.rmAccess.placeholder.title.BP']}
                        onChange={this.handleTextChange}
                        />
                    </div>
                    <div className= "column rm-search-button">
                    {this.state.BPCNvalue?
                        <Button 
                            className="button-height"
                            fullWidth
                            primary
                            loading = {this.props.rmAccess.showSpinner}
                            size='large'
                            onPress={this.handleSearchClick}
                        >{messages['app.rmAccess.searchButton']}</Button>:
                        <Button
                            className="button-height"
                            disabled
                            fullWidth
                            size='large'
                        >{messages['app.rmAccess.searchButton']}</Button>
                    }</div>
                    <div className= "column rm-search-button">
                        <Button 
                            className="button-height"
                            fullWidth
                            tertiary
                            size='large'
                            onPress={this.handleResetClick}
                        >{messages['app.rmAccess.resetButton']}</Button></div>
                </div>
            
            </div>


        );
    }
}

export default createContainer({
    $queries: {
        i18n: {
            messages: true,
        },
        rmLogout: { $call : 'rmAccess.logout'},
        rmAccess: {
            getContractsList: {$call: 'getContractsList'},
            showContractList: true,
            showSpinner: true,
            resetSearchVariables: {$call: 'resetSearchVariables'},
            showLogoutSpinner: true
        }
    }
})(SearchViewHeader);
